import { useEffect } from "react";
import * as SessionStorage from "../../../../../common-deprecated/SessionStorage";
import { loadUserSelected } from "../../redux/actions/BasketActions";
import type { BuildAndBuyDispatchType } from "../../redux/store";
import { useDispatch } from "../../../../../shared-logic/redux/store";
// This hook is used to initialize data used in the Customize
const useInitCustomize = (): void => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();

    useEffect(() => {
        // Load userSelected data from session.
        const userSelectedSession = SessionStorage.get("userSelected");
        if (userSelectedSession) dispatch(loadUserSelected(JSON.parse(userSelectedSession), true));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default useInitCustomize;
